// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"SJ-z","smallCardRow":"TJ-z","largeCardRow":"UJ-z","productSearchRow":"VJ-z","curatedRow":"WJ-z"};